import { addEventMergeIdIfVariationChangedAndExists } from '../../../_common/client/tracking';
import { ImagesSubComponent } from '../images.sub.component';
import { promoComboPresentation } from '@otto-ec/nexus-registry/promo/combo/presentation';

interface ComboPromoVariationChangedEventPayload {
    articleNumber: string;
    targetElement: HTMLElement;
    imageId: string;
    imagePreset: string;
    eventMergeId?: string;
    variationId: string;
}

export class ComboPromoButtonSubComponent extends ImagesSubComponent {
    public rootSelector = '.js_pdp_combo-promo-button';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        this.getImageIds();

        const comboPromoVariationChangedEventPayload: ComboPromoVariationChangedEventPayload = {
            articleNumber: this.getRootElement().dataset.articleNumber || '',
            targetElement: this.getRootElement(),
            imageId: this.getImageIds()[0],
            imagePreset: '$001PICT36$',
            variationId: this.getRootElement().dataset.variationId || '',
        };

        promoComboPresentation.variationChange.emit(addEventMergeIdIfVariationChangedAndExists(comboPromoVariationChangedEventPayload));
    }

    protected onItemChanged(index: number) {
        if (this.isVideo(index)) return;

        const imageId = this.getImageIds()[this.toImageIndex(index)];
        if (!imageId) return;

        promoComboPresentation.imageChange.emit({ imageId });
    }
}
